import { render, staticRenderFns } from "./TipoContratoList.vue?vue&type=template&id=2e750b6a"
import script from "./TipoContratoList.vue?vue&type=script&lang=js"
export * from "./TipoContratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports